export enum Roles {
  Admin = 'admin',
  Viewer = 'viewer',
  Approver = 'approver',
  Editor = 'editor'
}

export interface PurpleMenuItem {
  title: string
  icon: any
  roles?: Roles[]
  link?: string
  children: PurpleMenuItem[]
}

export interface PurpleUser {
  email: string
  emailVerified: boolean
  familyName: string
  givenName: string
  locale: 'en_US'
  name: string
  preferredUsername: string
  sub: string
  updatedAt: number
  zoneinfo: string
}

export interface PurpleNotification {
  id: string
  title: string
  subTitle: string
  date: Date
  unread: boolean
  actionUrl: string
}
